(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["box-showcase"] && !Shopify.designMode) return;
  try {
    (function(){
  document.querySelectorAll('.box-showcase').forEach(function(root){
    if(root.dataset.ready==='1') return;
    root.dataset.ready='1';
    var track=root.querySelector('[data-box-track]');
    var prev=root.querySelector('[data-box-prev]');
    var next=root.querySelector('[data-box-next]');
    function step(){
      var card=track&&track.querySelector('.box-showcase__card');
      return card ? card.getBoundingClientRect().width + 14 : 280;
    }
    if(prev) prev.addEventListener('click',function(){track.scrollBy({left:-step(),behavior:'smooth'});});
    if(next) next.addEventListener('click',function(){track.scrollBy({left:step(),behavior:'smooth'});});
  });
})();
  } catch(e) { console.error(e); }
})();

})();
